<template>
  <div class="toggle-tab">
    <template v-if="kind">
      <div v-if="kind === 1" class="tab-item" @click.stop="toggleKind(2)">
        <span class="tab-link">切换普通模版</span>
      </div>
      <div v-if="kind === 2" class="tab-item" @click.stop="toggleKind(1)">
        <span class="tab-link">切换意外模版</span>
      </div>
    </template>
    <template v-else>
      <div v-if="showType === 0" class="tab-item" @click.stop="toggle(1)">
        <span class="tab-link">按险种显示</span>
      </div>
      <div v-if="showType === 1" class="tab-item" @click.stop="toggle(0)">
        <span class="tab-link">按责任显示</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    showType: {
      type: Number,
      default: 0
    },
    kind: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      currentIndex: this.showType
    }
  },
  methods: {
    toggle (showType) {
      if (this.showType === showType) return
      this.$emit('toggle', showType)
    },
    toggleKind (kind) {
      if (this.kind === kind) return
      this.$emit('toggle-kind', kind)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import 'variable.css';

.toggle-tab {
  display: flex;
  align-items: center;
  z-index: 2;
  position: fixed;
  right: -2px;
  top: 38%;
  width: 0.5rem;
  height: 2.08rem;
  line-height: 1.2;
  text-align: center;
  font-size: 0.26rem;
  color: #fff;
  -webkit-tap-highlight-color: transparent;
  border-radius: 0.32rem 0 0 0.32rem;
  background-color: #000;
  opacity: 0.7;
}
@media screen and (device-width <= 320px) {
  .toggle-tab {
    top: 42%;
  }
}
</style>
